<template>
  <div class="user-status-root">
    <div class="current-gold">
      <img src="/static/img/coin.png" class="coin-image" />
      Gold:
      <strong>{{gold}}</strong> /
      <span class="current-rank">
        Rank:
        <strong>{{diversityRank}}</strong>
      </span>
    </div>

    <div @click="openDictionary" class="open-dictionary">
      <img src="/static/img/dictionary.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserStatus',
  computed: {
    gold() {
      return this.$store.state.game.assetManager.gold;
    },
    diversityRank() {
      return this.$store.state.game.unitManager.diversityRank;
    },
  },
  methods: {
    openDictionary() {
      this.$store.dispatch('setUserActionMode', { mode: 'unit-dictionary' });
    },
  },
};
</script>

<style scoped lang="scss">
.user-status-root {
  z-index: 100;
  $height: 1.6rem;
  font-size: 0.8rem;
  line-height: $height;

  .coin-image {
    width: $height;
    line-height: $height;
    display: block;
    float: left;
    margin-right: 0.5em;
  }

  strong {
    font-size: 1rem;
  }

  .current-gold {
    float: left;
    margin-right: 1rem;
    padding-top: 0.8rem;
  }

  .open-dictionary {
    float: left;
    cursor: pointer;
    transition: opacity 0.5s;
    padding: 0.5rem;

    &:hover {
      opacity: 0.8;
    }

    img {
      width: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/UserStatus.vue